export default __webpack_public_path__ + "static/media/19.4bdd58bf.png";